import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { message } from "antd";
import { AxiosError } from "axios";
import { createBrowserHistory } from "history";
import { render } from "react-dom";
import { Router } from "react-router-dom";
import App from "./components/App";
import Constants from "./constants/Common";
import { ToastProvider } from "./contexts/ToastContext";
import { handleError } from "./utils/error";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      onError: handleError,
    },
    mutations: {
      onError: ({ response }: AxiosError) => {
        message.config({
          maxCount: 1,
        });
        const err = response?.data?.errors?.[0];
        message.error(err ? err : Constants.statusMessage.error);
      },
    },
  },
});

if (process.env.NODE_ENV === "production") {
  const consoleMethods = {
    log: console.log,
    error: console.error,
    info: console.info,
    warn: console.warn,
    debug: console.debug,
    trace: console.trace,
  };

  const SUPPRESSED_WARNINGS = ["reactjs.org", "antd", "webpack-dev-server"];

  const invokeConsoleMethod = (method, msg, ...args) => {
    if (
      typeof msg === "string" &&
      !SUPPRESSED_WARNINGS.some((entry) =>
        msg.toLowerCase().includes(entry.toLowerCase()),
      )
    ) {
      consoleMethods[method](msg, ...args);
    }
  };

  console.log = (msg, ...args) => invokeConsoleMethod("log", msg, ...args);
  console.error = (msg, ...args) => invokeConsoleMethod("error", msg, ...args);
  console.info = (msg, ...args) => invokeConsoleMethod("info", msg, ...args);
  console.warn = (msg, ...args) => invokeConsoleMethod("warn", msg, ...args);
  console.debug = (msg, ...args) => invokeConsoleMethod("debug", msg, ...args);
  console.trace = (msg, ...args) => invokeConsoleMethod("trace", msg, ...args);
}

const rootEl = document.getElementById("root");
export const history = createBrowserHistory();
render(
  <ToastProvider>
    <QueryClientProvider client={queryClient}>
      <Router history={history}>
        <App />
      </Router>
    </QueryClientProvider>
  </ToastProvider>,
  rootEl,
);
